import { AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, DoCheck, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/modules/user/services/authentication.service';
import { BannerContentDirective } from '../../directives/banner/banner-content.directive';
import { BannerMessage } from '../../services/banner/banner-message';
import { BannerService } from '../../services/banner/banner.service';

export interface IHaveOptionalDataProperty {
    data?: any;
}

@Component({
    selector: 'cas-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements AfterViewInit, DoCheck, OnInit {
    private bannerHeight = 0;

    @ViewChild(BannerContentDirective, {static: true}) public bannerContentDirective!: BannerContentDirective;
    @ViewChild('banner', { static: false }) private bannerElementRef: ElementRef<HTMLElement> ;

    public ngDoCheck() {
        const newBannerHeight = this.bannerElementRef?.nativeElement?.offsetHeight;
        if (this.bannerHeight !== newBannerHeight) {
            this.bannerHeight = newBannerHeight;
            this.bannerService.setBannerHeight(newBannerHeight);
        }
    }

    public ngAfterViewInit() {
        const newBannerHeight = this.bannerElementRef.nativeElement.offsetHeight;
        this.bannerHeight = newBannerHeight;
        this.bannerService.setBannerHeight(newBannerHeight);
    }

    private get bannerQueue() {
        return this.bannerService.bannerQueue;
    }

    private get isLoggedIn() {
        return this.authenticationService.isAuthenticated;
    }

    public get currentBannerIndex(): number {
        let key = 0;
        let max = -Infinity;

        this.bannerQueue.forEach((bannerMessage, k) => {
            if (max < bannerMessage.priority && (this.isLoggedIn || bannerMessage.showOnLoginScreen)) {
                max = bannerMessage.priority;
                key = k;
            }
        });

        return key;
    }

    public get currentBanner(): BannerMessage {
        if (this.bannerQueue && this.bannerQueue.length) {
            const banner = this.bannerQueue[this.currentBannerIndex];
            if (this.isLoggedIn || banner.showOnLoginScreen) {
                return banner;
            }
        }
        return null;
    }

    public get currentBannerStyle() {
        const style: any = {};
        const currentBanner = this.currentBanner;
        if (currentBanner) {
            if (currentBanner.color) {
                style.color = currentBanner.color;
            }

            if (currentBanner.backgroundColor) {
                style.backgroundColor = currentBanner.backgroundColor;
            }
        }

        return style;
    }

    public get color() {
        const style: any = {};
        const currentBanner = this.currentBanner;
        if (currentBanner && currentBanner.color) {
            style.color = currentBanner.color;
        }
        return style;
    }

    constructor(
        private cdr: ChangeDetectorRef,
        private bannerService: BannerService,
        private componentFactoryResolver: ComponentFactoryResolver,
        private authenticationService: AuthenticationService
    ) {
    }

    public ngOnInit() {
        this.bannerService.bannerEvent.subscribe((bannerMessage: BannerMessage) => {
            this.bannerQueue.push(bannerMessage);
            this.createMessageComponent();
            // Ensure that the parent component renders the correct banner
            this.cdr.detectChanges();
        });
        this.bannerService.bannerCloseEvent.subscribe(() => {
            this.createMessageComponent();
        });
    }

    public doBannerAction() {
        if (this.currentBanner && this.currentBanner.bannerAction) {
            this.currentBanner.bannerAction();
            this.closeCurrentBanner();
        }
    }

    public closeCurrentBanner() {
        this.bannerService.closeBanner(this.currentBanner.messageComponent);

        this.cdr.detectChanges();
    }

    private createMessageComponent() {
        if (!this.currentBanner || !this.currentBanner.messageComponent) {
            return;
        }
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory<IHaveOptionalDataProperty>(this.currentBanner.messageComponent);
        const viewContainerRef = this.bannerContentDirective.viewContainerRef;
        viewContainerRef.clear();
        const component = viewContainerRef.createComponent(componentFactory);
        component.instance.data = this.currentBanner.data;
    }
}
